module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-block', {
    staticClass: "home-understanding-report",
    attrs: {
      "block": "transparent"
    }
  }, [_c('div', {
    staticClass: "home-understanding-report__inner group group--first-last"
  }, [_c('div', {
    staticClass: "home-dentists__content"
  }, [_c('h1', {
    staticClass: "home-hero__heading h1 mt0 fw-semibold"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _vm._l((_vm.copy), function(p, index) {
    return _c('p', {
      key: index,
      staticClass: "p",
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  })], 2), _vm._v(" "), _c('div', {
    class: [
      "home-dentists__image",
      ("home-dentists__image--" + (_vm.animationClass ? "open" : "closed")) ]
  }, [_c('div', {
    staticClass: "home-dentists__image-wrapper"
  }, _vm._l((_vm.images.pages), function(image, index) {
    return _c('img', {
      key: index,
      class: [
        "home-dentists__paper",
        ("home-dentists__paper--" + index) ],
      attrs: {
        "src": image
      }
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af64e3d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/pages/understandingYourReport/Hero.vue
// module id = 291
// module chunks = 0